import React, { Component } from 'react';

import './styles.css';

export default class ModalUnsavedPage extends Component {

    onClose = e => {
        this.props.onClose && this.props.onClose(e);
    };

    discard = () => {
        this.props.onDiscard(true);
    }

    save = () => {
        this.props.onSave(true);
    }


    render() {
        if(!this.props.show) {
            return null;
        }
        return (
            <div className="modal-background">
                <div className="modal-unsave-container">
                    <div className="modal-unsave-form">
                        <p className="unsaved-text">There are unsaved changes. Please select one of the following actions</p> 
                    </div>
                    <div className="modal-unsave-buttons">
                        <button type="button" className="btn btn-warning btn-sm btn-unsave" onClick={e => {this.onClose(e)}}>Return</button>
                        <button type="button" className="btn btn-warning btn-sm btn-unsave" onClick={this.discard}>Discard</button>
                        <button type="button" className="btn btn-warning btn-sm btn-unsave" onClick={this.save}>Save</button>
                    </div> 
                </div>
            </div>
            

        );
    }

}